module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/champagne-103d345a2b5bdc8b1c3d367784cf628e.png";